import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import menuStore from '@/stores/menu-store.js'
import IsIos from '@/mixins/is-ios.js'

export default {
  name: 'MenuContainer',
  mixins: [IsIos, CurrentUserResolver],
  data: function () {
    return {
      animateIn: false,
      buttons: [],
    }
  },
  computed: {
    isOpen() {
      this.animateIn = menuStore.state.isOpen
      this.buttons = menuStore.state.buttons
      return menuStore.state.isOpen
    },
  },
  methods: {
    close() {
      this.animateIn = false
      setTimeout(this.commitClose, 200)
    },
    commitClose() {
      menuStore.commit('close')
    },
    executeCallback(button) {
      !!button.callback ? button.callback() : null
    },
  },
}
